import React from 'react';

import Router from 'next/router';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import isEmail from '@tmap/mmm-core/isEmail';
import nestGet from '@tmap/mmm-core/nestGet';
import { Field, Form } from '@tmap/mmm-style-guide/src/final-form/react';
import { Button } from '@tmap/mmm-style-guide/src/Button';
import { Card } from '@tmap/mmm-style-guide/src/Card';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import TextFieldField from '@tmap/mmm-style-guide/src/fields/TextFieldField';

import client from '../client';
import Metatags from '../components/metatags';
import FullWrapper from '../layouts/fullWrapper';
import { getClient } from '../lib/apiClient';

const PageHeader = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(5),
  fontWeight: 700,
}));

const FormCard = styled(Card)(({ theme }) => ({
  padding: `${theme.spacing(6)} ${theme.spacing(10)}`,
  marginBottom: theme.spacing(5),
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const email = (value) => (
  value && !isEmail(value)
    ? 'Invalid email address'
    : undefined
);

function ListCommunity(props) {
  const {
    doc,
  } = props;
  const dispatch = useDispatch();

  const formSubmit = (values) => {
    dispatch(async (reDispatch, getState) => {
      const token = nestGet(getState(), ['authStore', 'id_token']);
      let url = '/api/v1/formstash/upsert';
      if (!token) {
        url = '/api/v1/formstash/noauth/upsert';
      }
      const newKey = await getClient(process.env.NEXT_PUBLIC_API_DOMAIN, getState).post(url, {
        fid: values.fid,
        formName: 'listCommunity',
        data: values,
      });
      Router.push('/list-community-thanks');
    });
  };

  return (
    <>
      <Metatags
        title={doc.leadCopy}
        description={doc.subLeadCopy}
        canonical={`${process.env.NEXT_PUBLIC_CANONICAL_DOMAIN}/list-community`}
      />
      <FullWrapper inset={10} headerOffset>
        <Form
          onSubmit={formSubmit}
          initialValues={{
            fid: uuidv4(),
          }}
        >
          {
            ({
              values,
              invalid,
              pristine,
              submitting,
              handleSubmit,
            }) => (
              <form onSubmit={handleSubmit}>
                <Grid container spacing={10}>
                  <Grid item xs={12} md={6}>
                    <PageHeader variant='h3' component='h1' gutterBottom color='dark' fontFamily='serif'>{doc.leadCopy}</PageHeader>
                    <Typography variant='body1'>{doc.subLeadCopy}</Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormCard elevation={3}>
                      <Grid container spacing={2}>
                        <Grid item sx={{ textAlign: 'center' }} xs={12}>
                          <Typography variant='h5'>Tell us about yourself</Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Field
                            name='community'
                            component={TextFieldField}
                            label='Community'
                            color='primary'
                            fullWidth
                            variant='outlined'
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Field
                            name='firstName'
                            component={TextFieldField}
                            label='First Name'
                            color='primary'
                            fullWidth
                            variant='outlined'
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Field
                            name='lastName'
                            component={TextFieldField}
                            label='Last Name'
                            color='primary'
                            fullWidth
                            variant='outlined'
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Field
                            name='email'
                            component={TextFieldField}
                            label='E-mail'
                            validate={email}
                            color='primary'
                            fullWidth
                            variant='outlined'
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Field
                            name='programLink'
                            component={TextFieldField}
                            label='Link to program information'
                            color='primary'
                            fullWidth
                            variant='outlined'
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Field
                            name='questions'
                            component={TextFieldField}
                            label='Questions or comments for our team'
                            color='primary'
                            fullWidth
                            multiline
                            rows={5}
                            variant='outlined'
                          />
                        </Grid>
                        <Grid item xs={12} sx={{ textAlign: 'right' }}>
                          <Button variant='contained' color='convert' type='submit' disabled={invalid || pristine || submitting}>Get Started</Button>
                        </Grid>
                      </Grid>
                    </FormCard>
                  </Grid>
                </Grid>
              </form>
            )
          }
        </Form>
      </FullWrapper>
    </>
  );
}

export const getServerSideProps = async (context) => {
  const settings = await client.fetch(`
    *[_id == "communitySubmissionSettings"][0]
    `);

  return { props: { doc: settings } };
};

export default ListCommunity;
